<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      class="ag-theme-balham ag-grid-listado-requisitos-documentales"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :rowSelection="rowSelection"
      :pagination="pagination"
      :rowClassRules="rowClassRules"
      :columnDefs="columnDefs"
      :rowData="rowData"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro } from '../../utils/funciones';

export default {
  name: 'ListadoRequisitosDocumentales',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'PROPÓSITO',
          field: 'tipoDocumentoPersona.proposito',
          minWidth: 150,
        },
        {
          headerName: 'TIPO DOCUMENTO PERSONA',
          field: 'tipoDocumentoPersona.nombre',
          minWidth: 200,
        },
        {
          headerName: 'UNIDAD DE NEGOCIO',
          field: 'categoria.unidadNegocio.nombre',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'CATEGORÍA',
          field: 'categoria.nombre',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'INSTITUCIÓN',
          field: 'institucion.nombre',
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'REQUISITO PREVIO',
          field: 'requisitoAnterior.tipoDocumentoPersona.nombre',
          minWidth: 200,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-requisitos-documentales {
  height: calc(var(--vh, 1vh) * 100 - 17rem);
}
</style>
  